const steps = [
  {
    number: "01",
    icon: "ri-send-plane-line",
    title: "Envio do Contrato",
    description:
      "Você nos envia o contrato bancário pelo WhatsApp ou e-mail. Pode ser foto, PDF ou qualquer formato que você tiver disponível.",
    detail: "Simples e rápido – tudo pelo celular",
  },
  {
    number: "02",
    icon: "ri-microscope-line",
    title: "Análise Técnica",
    description:
      "Nossa equipe realiza análise técnica minuciosa do contrato, calculando as taxas cobradas versus as taxas legais permitidas.",
    detail: "Resultado em até 48 horas",
  },
  {
    number: "03",
    icon: "ri-quill-pen-line",
    title: "Estratégia Jurídica",
    description:
      "Com base na análise, definimos a melhor estratégia: negociação extrajudicial com o banco ou ação judicial para revisão de juros abusivos.",
    detail: "Sempre o melhor caminho para você",
  },
  {
    number: "04",
    icon: "ri-user-star-line",
    title: "Acompanhamento Completo",
    description:
      "Você é acompanhado em todas as etapas do processo, com informações claras e transparentes sobre o andamento do seu caso.",
    detail: "Você nunca fica no escuro",
  },
];

export default function ComoFunciona() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-[#B32025] text-xs font-semibold uppercase tracking-widest font-sans">
            Processo
          </span>
          <h2 className="font-serif text-[#1A1A1A] text-3xl lg:text-4xl font-bold mt-3 mb-5">
            Como funciona a{" "}
            <em className="text-[#B32025] not-italic">revisão de juros</em>
          </h2>
          <p className="text-[#2C2C2C]/70 text-base leading-relaxed font-sans">
            Um processo transparente e estruturado em 4 etapas para garantir o melhor resultado no combate a juros abusivos.
          </p>
        </div>

        {/* Steps */}
        <div className="relative">
          {/* Connector line desktop */}
          <div className="hidden lg:block absolute top-16 left-0 right-0 h-px bg-[#E6E6E6] mx-24" />

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {steps.map((step, idx) => (
              <div
                key={step.number}
                className="group relative flex flex-col items-center text-center cursor-default"
              >
                {/* Number bubble */}
                <div className="relative z-10 w-14 h-14 flex items-center justify-center rounded-full bg-white border-2 border-[#B32025] mb-6 transition-all duration-300 group-hover:bg-[#B32025]">
                  <i className={`${step.icon} text-xl text-[#B32025] group-hover:text-white leading-none transition-colors`} />
                </div>

                {/* Arrow mobile */}
                {idx < steps.length - 1 && (
                  <div className="lg:hidden absolute top-16 left-1/2 translate-x-6 w-4 h-4 flex items-center justify-center text-[#BFBFBF]">
                    <i className="ri-arrow-down-line text-sm leading-none" />
                  </div>
                )}

                <span className="text-[#B32025] text-xs font-bold font-sans tracking-widest mb-2">{step.number}</span>
                <h3 className="font-serif text-[#1A1A1A] text-lg font-bold mb-3">{step.title}</h3>
                <p className="text-[#2C2C2C]/70 text-sm leading-relaxed font-sans mb-4">{step.description}</p>
                <div className="inline-flex items-center gap-1 bg-[#B32025]/8 px-3 py-1.5 rounded-full">
                  <div className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-check-line text-xs text-[#B32025] leading-none" />
                  </div>
                  <span className="text-[#B32025] text-xs font-semibold font-sans">{step.detail}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="flex justify-center mt-16 px-6">
          <a
            href="https://wa.me/5554996914900?text=Ol%C3%A1%2C%20quero%20iniciar%20o%20processo%20de%20revis%C3%A3o%20do%20meu%20contrato."
            target="_blank"
            rel="noopener noreferrer"
            className="w-full sm:w-auto flex items-center justify-center bg-[#B32025] hover:bg-[#8E1A1E] text-white font-semibold px-8 py-4 rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer text-sm sm:text-base"
          >
            Iniciar minha revisão de juros agora
          </a>
        </div>
      </div>
    </section>
  );
}
